import angular from 'angular';
import controller from './checkbox.controller';
import template from './checkbox.html';
import CheckboxComponent from './checkbox.component';

const checkboxConfig = /* @ngInject */ (
	/** @type {any} */ KformComponentsProvider,
) => {
	KformComponentsProvider.register('checkbox', {
		title:      'Check Box',
		template,
		tableView:  (/** @type {any} */ data) => (data ? 'Yes' : 'No'),
		controller,
		children:   false,
		selectable: true,
		settings:   new CheckboxComponent(),
		icon:       'fa fa-check-square',
		onEdit:     /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.inputTypes = [
				{
					name:  'checkbox',
					title: 'Checkbox',
				},
				{
					name:  'radio',
					title: 'Radio',
				},
			];

			$scope.labelPositions = [
				{
					value: 'top',
					title: 'Top',
				},
				{
					value: 'left',
					title: 'Left',
				},
				{
					value: 'right',
					title: 'Right',
				},
				{
					value: 'bottom',
					title: 'Bottom',
				},
			];

			if (!$scope.component.labelPosition) {
				$scope.component.labelPosition = 'right';
			}
		},
		views:      [
			{
				name:     'Display',
				template: 'kform/components/checkbox/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/common/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
	});
};

export default angular.module('app').config(checkboxConfig);
